import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=4ad0301c&"
import script from "./Alerts.vue?vue&type=script&lang=ts&"
export * from "./Alerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports